module.exports = __webpack_public_path__ + "static/media/dentvr2.d31ff2bc.png";